// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TextContent_wrapper__2hIea","mcBook":"TextContent_mcBook__19WDa","phone":"TextContent_phone__3EkQ5","spread":"TextContent_spread__3Ijk_"};